import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import CheckMarkIcon from 'dibs-vg/dist/react/checkmark';
import CloseIcon from 'dibs-vg/dist/react/close';

// Helpers
import { mutations } from '../../constants';

// Styles
import styles from './styles/ErrorSuccessModal.scss';

const ErrorSuccessModal = ({ description, isOpen, onClose, title, type }) => {
    const IconComponent = type === 'error' ? CloseIcon : CheckMarkIcon;
    const titleEl = (
        <Fragment>
            <div className={styles.result}>
                <IconComponent className={styles.icon} />
            </div>
            <div data-tn="response-modal-message-title" className={styles.title}>
                {title}
            </div>
        </Fragment>
    );
    return (
        <ModalContainer onClose={onClose} isOpen={isOpen} modalPosition="center">
            <ModalCloseButton onClick={onClose} />
            <BarHeader title={titleEl} />
            <ModalBody>
                <div className={styles.description}>{description}</div>
            </ModalBody>
        </ModalContainer>
    );
};

ErrorSuccessModal.defaultProps = {
    type: 'error',
};

ErrorSuccessModal.propTypes = {
    description: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    title: PropTypes.string,
    type: PropTypes.oneOf([
        mutations.responses.COMPLETE,
        mutations.responses.ERROR,
        mutations.responses.NULL,
        mutations.responses.SUCCESS,
    ]),
};

export default ErrorSuccessModal;
